var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOngoingContesticon = function SvgOngoingContesticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.29 3.13 13.077 7.356a1 1 0 0 1 .059 1.707L8.349 20.775A1 1 0 0 1 6.8 19.94V4.001a1 1 0 0 1 1.49-.871M4.6 4A.8.8 0 1 0 3 4v16a.8.8 0 0 0 1.6 0z"
  })));
};
export default SvgOngoingContesticon;